import { render } from "./MsCreatechannel.vue?vue&type=template&id=f1c11bf6"
import script from "./MsCreatechannel.vue?vue&type=script&lang=js"
export * from "./MsCreatechannel.vue?vue&type=script&lang=js"

import "./MsCreatechannel.vue?vue&type=style&index=0&id=f1c11bf6&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__